<template>
  <form method="get" v-bind:action="downloadLink" class="download-form">
    <button class="fvhm-download"
      type="submit"
      :class="downloadIconClass" 
      data-placement="bottom"
      title="Download monitor data">Data</button>
  </form>
</template>

<script>
export default {
  name: 'download-button',
  data() {
    return {
      downloadLink: process.env.DOWNLOAD_URL,
      downloadIconClass: process.env.DOWNLOAD_ICON,
    };
  },
};
</script>

<style>
  .fvhm-download {
    color: #fff;
    background-color: #265EAC;
    border: none;
    border-radius: 2px;
    width: auto;
    height: 30px;
    text-align: left;
    vertical-align: center;
    float: right;
    margin: 8px 0 0 10px;
    padding-right: 30px;
    padding-top: 5px;
    background-position: 36px center;
    background-size: 20px 15px;
    background-repeat: no-repeat;
  }
  .prod-download-icon {
    background-image: URL('/assets/images/download.png');
  }
  .dev-download-icon {
    background-image: URL('/assets/images/download.png');
  }
  @media(max-width: 500px) {
    .download-form {
      align-self: flex-end;
      margin-left: -10px;
      order: -3;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// Download.vue?09fb9265